/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A9Inputs */

const et_faq_a9 = /** @type {(inputs: Faq_A9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO ei ole ühekordne projekt, sest Google'i algoritmid, konkurendid ja kliendi otsingukäitumine muutuvad pidevalt. Esile jõudmine ja seal püsimine nõuab regulaarset tööd: tehnilisi parandusi, sisuuuendusi, konkurendianalüüsi, linkide kasvatamist ja tulemuste mõõtmist. ScalingWebsi töö on üles ehitatud 90-päevasele algsele kasvuperioodile. Pärast seda saab koostööd jätkata igakuiselt. See annab piisavalt aega tulemuste loomiseks, kuid ei seo sind ebamõistlikult pika lepinguga.`)
};

const en_faq_a9 = /** @type {(inputs: Faq_A9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO is not a one-time project because Google's algorithms, your competitors, and customer search behavior keep changing. Reaching top positions and staying there requires ongoing work: technical fixes, content updates, competitor analysis, link growth, and performance measurement. ScalingWebs is built around an initial 90-day growth phase. After that, collaboration can continue month to month. This gives enough time to create results without locking you into an unreasonable long-term contract.`)
};

/**
* | output |
* | --- |
* | "SEO is not a one-time project because Google's algorithms, your competitors, and customer search behavior keep changing. Reaching top positions and staying t..." |
*
* @param {Faq_A9Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a9 = /** @type {((inputs?: Faq_A9Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A9Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a9(inputs)
	return en_faq_a9(inputs)
});